import { Instance } from 'mobx-state-tree';
import { PharmacyStore } from '../../../store';
import { inject, observer } from 'mobx-react';
import React from 'react';
import SelectInputFormField from './SelectInputFormField';
import { IItemRendererProps } from '@blueprintjs/select';
import { MenuItem } from '@blueprintjs/core';
import { TLCode } from '../../../common/enums';
import { toJS } from 'mobx';
import withTranslate, { WithTranslateProps } from '../WithTranslate';
import { Pharmacy } from '../../../store/models/Pharmacy';

interface PharmacyFormFieldProps extends WithTranslateProps {
  PharmacyStore?: Instance<typeof PharmacyStore>;
  pharmacyList?: Array<Instance<typeof Pharmacy>>;
  onPharmacyIdChanged?: (pharmacyId: number | undefined) => void;
}

@inject('PharmacyStore')
@observer
class PharmacyFormField extends React.Component<PharmacyFormFieldProps> {
  renderPharmacyMenuItem(item: Instance<typeof Pharmacy>, { handleClick, index, modifiers }: IItemRendererProps) {
    if (modifiers.matchesPredicate) {
      return (
        <MenuItem
          key={`pharmacy-${index}`}
          active={modifiers.active}
          onClick={handleClick}
          text={item.apbNumber + ' - ' + item.name!}
        />
      );
    } else {
      return null;
    }
  }

  filterPharmacy = (query, pharmacy) => {
    // return pharmacy.name!.toLowerCase().indexOf(query.toLowerCase()) >= 0;
    return (
      (pharmacy.apbNumber + ' - ' + pharmacy.name! + ' - ' + pharmacy.city)
        .toLowerCase()
        .indexOf(query.toLowerCase()) >= 0
    );
  };

  render() {
    const { PharmacyStore, ...otherProps } = this.props;
    let { pharmacyList } = this.props;
    if (pharmacyList == null) {
      pharmacyList = PharmacyStore!.dataList;
    }

    return (
      <SelectInputFormField
        label={TLCode.PHARMACY}
        name="pharmacyId"
        inline={true}
        items={toJS(pharmacyList)}
        itemValueGetter={(item: { pharmacyId: number; name: string }) => item.pharmacyId}
        valueItemGetter={(value: any) => PharmacyStore!.getById(value)!}
        inputValueRenderer={(item: any) => (item != null ? item.apbNumber + ' ' + item.name! : '')}
        itemRenderer={this.renderPharmacyMenuItem}
        itemPredicate={this.filterPharmacy}
        allowEmpty={true}
        identifier={'pharmacyId'}
        elementLabel={'name'}
        labelSelectAnElement={this.props.translate(TLCode.CHOOSE_A_PHARMACY)}
        helperText={this.props.translate(TLCode.CHOOSE_A_PHARMACY)}
        placeholderSelection={TLCode.CHOOSE_A_PHARMACY}
        afterItemSelected={otherProps.onPharmacyIdChanged}
        {...otherProps}
      />
    );
  }
}

export default withTranslate(PharmacyFormField);
